/**
 * 카카오 로컬 REST의 주소. FE repo `src/features/problem/constants/kakaoLocal.ts`와 같은 값이다.
 *
 * **절대 URL 금지 원칙(§4-13)의 예외가 아니다** — 그 원칙은 *우리 서비스의* 주소를 소스에
 * 박지 말라는 것이고(인계 시 도메인이 바뀐다), 여기는 외부 벤더가 고정해 둔 공개 엔드포인트다.
 */

export const ENDPOINT = 'https://dapi.kakao.com/v2/local/search/address.json'
/**
 * 좌표 → 행정동. **동 이름만으로 검색하면 `h_code`가 빈 문자열로 온다**
 * (`address_type: "REGION"` — 2026-08-25 실측: 「가학동」). 그때는 그 자리의 좌표를 이것으로
 * 되물어 행정동을 확정한다. 반환 배열에 법정동(`B`)·행정동(`H`) 두 줄이 오고 우리는 `H`를 쓴다.
 */
export const REGION_ENDPOINT = 'https://dapi.kakao.com/v2/local/geo/coord2regioncode.json'
/** 장소명(POI) 검색. 주소 검색이 못 찾는 「광명동굴」 같은 이름을 이쪽이 찾는다. */
export const KEYWORD_ENDPOINT = 'https://dapi.kakao.com/v2/local/search/keyword.json'
/** 한 번에 받는 결과 수. 목록이 길면 고르기 어렵다. */
export const PAGE_SIZE = 10
